/* eslint-disable max-lines */
import $ from 'jquery';
import {trigger} from '../../utils/events.js';

const events = {
    fireIngredientEvent: createEvent('Supplement Wizard', 'View Ingredient Totals Click', 'Results Click'),
    fireEmailClickEvent: createEvent('Supplement Wizard', 'Email Recommendations Click', 'Open'),
    fireEmailCancelEvent: createEvent('Supplement Wizard', 'Email Recommendations Click', 'Cancel'),
    fireEmailSendResultsEvent: createEvent('Supplement Wizard', 'Email Recommendations Click', 'Send Results'),
    addLifestyleExitEventListener: createExitListenerEvent('Lifestyle Exit the Wizard'),
    addHealthExitEventListener: createExitListenerEvent('Health Exit the Wizard'),
    addPreferencesExitEventListener: createExitListenerEvent('Preferences Exit the Wizard'),
    addBudgetExitEventListener: createExitListenerEvent('Budget Exit the Wizard'),
    addRecommendationsSaveAndExitEventListener: createExitListenerEvent('Recommendations Save & Exit'),
    addIngredientSaveAndExitEventListener: createExitListenerEvent('Ingredient Totals Save & Exit'),
    addCompareResultsSaveAndExitEventListener: createExitListenerEvent('Compare Results Save & Exit'),
    fireConfirmModalOpenEvent: createEvent('Supplement Wizard', 'Exit Modal Click', 'Open'),
    fireConfirmModalConfirmEvent: createEvent('Supplement Wizard', 'Exit Modal Click', 'Yes'),
    fireConfirmModalCancelEvent: createEvent('Supplement Wizard', 'Exit Modal Click', 'No'),
    addLifestyleProgressClickEventListener: createProgessIndicatorListenerEvent(),
    addHealthProgressClickEventListener: createProgessIndicatorListenerEvent(),
    addPreferenceProgressClickEventListener: createProgessIndicatorListenerEvent(),
    addBudgetProgressClickEventListener: createProgessIndicatorListenerEvent(),
    addRecommendationsProgressClickEventListener: createProgessIndicatorListenerEvent(),
    fireSupportLevelEvent: function(supportLevel) {
        trigger('Supplement Wizard', 'Preferences Click', supportLevel.name());
    },
    fireShowByIngredientEvent: function(show) {
        if (show) {
            trigger('Supplement Wizard', 'View Ingredient Totals', 'By Ingredient');
        }
    },
    fireShowBySupplementEvent: function(show) {
        if (show) {
            trigger('Supplement Wizard', 'View Ingredient Totals', 'By Supplement');
        }
    },
    fireIngredientExpandEvent: function(show) {
        if (show) {
            trigger('Supplement Wizard', 'View Ingredient Totals', 'By Ingredient Totaled');
        }
    },
    fireNavigationEvent: function(location) {
        if (location) {
            trigger('Supplement Wizard', 'Screen Navigation', location.pathname + location.hash);
        }
    },
    fireDesiredBudgetEvent: function() {
        trigger('Supplement Wizard', 'Budget Click', '');
    },
    addPreferencesSkipEventListener: function(viewmodel) {
        var supportLevel = viewmodel.selectedSupportLevel();

        $('.wizard-continue-button[data-route="#budget"]')
            .off()
            .on('click', function() {
                if (supportLevel === viewmodel.selectedSupportLevel()) {
                    trigger('Supplement Wizard', 'Preferences Skip', supportLevel.name());
                }
            });
    },
    addBudgetSkipEventListener: function(viewmodel) {
        var desiredBudget = viewmodel.desiredBudget();

        $('.wizard-continue-button[data-route=""]')
            .off()
            .on('click', function() {
                if (desiredBudget === viewmodel.desiredBudget()) {
                    trigger('Supplement Wizard', 'Budget Skip', '');
                }
            });
    },
    oneTimeSubscription: function(property, callback) {
        var subscription = property.subscribe(function(value) {
            subscription.dispose();
            callback(value);
        });
    },
    addToCartEventListener: function() {
        var event = createEvent('Supplement Wizard', 'Add to Cart', 'Wizard Add to Cart');
        $('.add-to-cart-event')
            .off('click', event)
            .on('click', event);
    },
    addBackToBudgetEventListener: function() {
        $('[data-route="#budget"]')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Recommendations Top'));
    },
    addHealthEventListeners: function() {
        $('.wizard-submit-button').on('click', createEvent('Supplement Wizard', 'Completed Health', ''));
        this.addHealthGoBackEventListener();
        this.addHealthExitEventListener();
        this.addHealthProgressClickEventListener();
    },
    addRecommendationViewmodelSubscriptions: function(viewmodel) {
        viewmodel.shouldShowIngredientsByIngredient.subscribe(this.fireShowByIngredientEvent);
        viewmodel.shouldShowIngredientsBySupplement.subscribe(this.fireShowBySupplementEvent);

        if (viewmodel.ingredientsByIngredient()) {
            viewmodel.ingredientsByIngredient().forEach(
                function(ingredient) {
                    ingredient.isOpen.subscribe(this.fireIngredientExpandEvent.bind(this));
                }.bind(this)
            );
        } else {
            var subscription = viewmodel.ingredientsByIngredient.subscribe(
                function(ingredients) {
                    if (ingredients) {
                        ingredients.forEach(
                            function(ingredient) {
                                ingredient.isOpen.subscribe(this.fireIngredientExpandEvent.bind(this));
                            }.bind(this)
                        );
                        subscription.dispose();
                    }
                }.bind(this)
            );
        }

        this.addSupplementChangeEventSubscription(viewmodel);
    },
    addRecommendationsEventListeners: function($wizardCategories) {
        this.addBackToBudgetEventListener();
        this.addToCartEventListener();
        this.addCategoryClickEventListener($wizardCategories);
        this.addCompareClickEventListeners($wizardCategories);
        this.addReadMoreEventListeners($wizardCategories);
        this.addRecommendationsSaveAndExitEventListener();
        this.addRecommendationsProgressClickEventListener();
    },
    addReadMoreEventListeners: function($wizardCategories) {
        $wizardCategories.on(
            'click',
            '.wizard-read-more',
            createEvent('Supplement Wizard', 'Read More Click', 'Supplement Wizard')
        );
    },
    addCompareClickEventListeners: function($wizardCategories) {
        $wizardCategories.on(
            'click',
            '.wizard-compare-event',
            createEvent('Supplement Wizard', 'Compare Results Click', 'Supplement Wizard')
        );
    },
    addCategoryClickEventListener: function($wizardCategories) {
        $wizardCategories.on(
            'click',
            'input[type=checkbox]',
            createEvent('Supplement Wizard', 'Checkboxes Click', 'Supplement Wizard')
        );
    },
    addHealthGoBackEventListener: function() {
        $('body').on('click', '.go-back-event', function(e) {
            trigger(
                'Supplement Wizard',
                'Go Back Click',
                isFooterElement(e.currentTarget) ? 'Health Bottom' : 'Health Top'
            );
        });
    },
    addLifestyleGoBackEventListener: function() {
        $('body').on('click', '.go-back-event', function(e) {
            trigger(
                'Supplement Wizard',
                'Go Back Click',
                isFooterElement(e.currentTarget) ? 'Lifestyle Bottom' : 'Lifestyle Top'
            );
        });
    },
    addExitEventListener: function() {
        $('body').on('click', '.exit-event', createEvent('Supplement Wizard', 'Exit the Wizard', 'Supplement Wizard'));
    },
    fireLifeStyleCompleted: function() {
        trigger('Supplement Wizard', 'Completed Lifestyle', 'Supplement Wizard');
        handleDisciplineEvent();
    },
    addSupplementChangeEventSubscription: function(viewmodel) {
        viewmodel.supplementCategories().forEach(function(category) {
            category.selectedSupplement.subscribe(
                createEvent('Supplement Wizard', 'Choose a Supplement Click', 'Supplement Wizard')
            );
        });
    },
    addLifeStyleEventListeners: function() {
        $('.wizard-submit-button').on('click', this.fireLifeStyleCompleted);
        this.addLifestyleGoBackEventListener();
        this.addLifestyleExitEventListener();
        this.addLifestyleProgressClickEventListener();
    },
    addNewHorseEventListener: function($form) {
        $form.on('submit', function() {
            var $recipient = $('#RecipientName');

            if ($recipient.val()) {
                trigger('Supplement Wizard', 'Add a horse', '');
            }
        });
    },
    addPreferencesBackEvent: function() {
        $('.wizard-header-actions .go-back-event')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Preferences Top'));

        $('.wizard-footer-actions .go-back-event')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Preferences Bottom'));
    },
    addBudgetBackEvent: function() {
        $('.wizard-header-actions .go-back-event')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Budget Top'));

        $('.wizard-category-options .go-back-event')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Budget Bottom'));
    },
    addIngredientBackEventListener: function() {
        $('[data-route=""]')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Ingredient Top'));
    },
    addEmailIngredientsEventListener: function() {
        $('#ingredient-email-trigger')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Email Ingredient Totals', 'Supplement Wizard'));
    },
    addIngredientTotalEvents: function() {
        this.fireIngredientEvent();
        this.addIngredientBackEventListener();
        this.addIngredientSaveAndExitEventListener();
    },
    addBudgetRouteEvents: function(viewmodel) {
        this.addBudgetBackEvent();
        this.addBudgetExitEventListener();
        this.addBudgetSkipEventListener(viewmodel);
        this.oneTimeSubscription(viewmodel.desiredBudget, events.fireDesiredBudgetEvent);
        this.addBudgetProgressClickEventListener();
    },
    addPreferenceRouteEvents: function(viewmodel) {
        this.addPreferencesBackEvent();
        this.addPreferencesSkipEventListener(viewmodel);
        this.addPreferencesExitEventListener();
        this.addPreferenceProgressClickEventListener();
    },
    addGetStartedEventListener: function($form) {
        $form
            .on('click', '.get-started-event', createEvent('Supplement Wizard', 'Get Started', ''))
            .on('click', '.get-view-results-event', createEvent('Supplement Wizard', 'View Results', ''));
    },
    addPreviousResultEventListener: function($form) {
        $form.on(
            'change',
            '.previous-result-event',
            createEvent('Supplement Wizard', 'Select a horse previous results', '')
        );
    },
    addCompareSupplementsRouteEvents: function() {
        this.addCompareSupplementsEventListener();
        this.addCompareResultsSaveAndExitEventListener();
    },
    addCompareSupplementsEventListener: function() {
        $('.wizard-header-actions [data-route=""]')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Compare Results Top'));

        $('.wizard-button-back.showOnMobile[data-route=""], .hideOnMobile .wizard-continue-button[data-route=""]')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Go Back Click', 'Compare Results Bottom'));
    },
    addSelectHorseEventListener: function($form) {
        $form.on('change', '.select-horse-event', createEvent('Supplement Wizard', 'Select a horse', ''));
    }
};

export default events;

function isFooterElement(element) {
    return $(element)
        .parent()
        .hasClass('wizard-footer-actions');
}

function createExitListenerEvent(label) {
    return function() {
        $('.wizard-header .exit-event')
            .off()
            .on('click', createEvent('Supplement Wizard', 'Exit the Wizard', label));
    };
}

function createProgessIndicatorListenerEvent() {
    return function() {
        $('.wizard-steps > li')
            .off()
            .on('click', function(e) {
                var label = /health|about/gi.test(e.currentTarget.innerText)
                    ? /health/gi.test(e.currentTarget.innerText)
                        ? 'Health'
                        : 'About'
                    : e.currentTarget.innerText;
                trigger('Supplement Wizard', 'Progress Indicator Click', label);
            });
    };
}

function createEvent(category, action, label) {
    return function() {
        trigger(category, action, label);
    };
}

function getTextFromSelection($element) {
    return $element
        .find('option:selected')
        .text()
        .trim();
}

function getPrimaryRidingStyle() {
    return getTextFromSelection($('#Answers_456'));
}

function getCheckedRadioButtonLabelText(name) {
    return $('[name="' + name + '"]:checked + label').map(function(index, item) {
        return item.innerText.trim();
    });
}

function getMostOftenRidingStyle() {
    return getTextFromSelection($('#Answers_490'));
}

function getWesternPrimaryDiscipline() {
    return getCheckedRadioButtonLabelText('Answers_458');
}

function getEnglishPrimaryDiscipline() {
    return getCheckedRadioButtonLabelText('Answers_457');
}

function handleDisciplineEvent() {
    var style = getPrimaryRidingStyle();

    if (style === 'I am not a rider') {
        trigger('Supplement Wizard', 'I am not a rider', '');
    } else if (style === 'Both') {
        trigger('Supplement Wizard', 'Both', getMostOftenRidingStyle());
    } else if (style === 'Western') {
        getWesternPrimaryDiscipline().each(function(index, discipline) {
            trigger('Supplement Wizard', 'Western', discipline);
        });
    } else if (style === 'English') {
        getEnglishPrimaryDiscipline().each(function(index, discipline) {
            trigger('Supplement Wizard', 'English', discipline);
        });
    }
}
